// extracted by css-extract-rspack-plugin
export default {"barLabel":"barLabel-RUsgTz"};